import React, { useEffect, useRef, useState } from "react";
import styled, { useTheme } from "styled-components";
import { useTranslate } from '@tolgee/react';
import SearchMenu from "../GenericComponents/SearchMenu";
import { ReactComponent as GroupIcon } from "../../Assets/iconsv2/generic/newGroup.svg";
import { ReactComponent as QcIcon } from "../../Assets/iconsv2/generic/newQc.svg";
import { CHAT, GROUP, QUICK_CHAT } from "../../Constants/constantValues";
import FoundContactElement from "./FoundContactElement";
import { useAuthService } from "../../Context/AuthContext";
import { useConversationService } from "../../Context/ConversationsContext";
import { cloneDeep, isArray } from "lodash";
import { useGenericComponentsStateService } from "../../Context/GenericComponentsStateContext";
import { ReactComponent as GenericAvatar } from "../../Assets/iconsv2/generic/GenericAvatar.svg";
import { ReactComponent as CloseBtn } from "../../Assets/iconsv2/generic/closeBtn.svg";

import { VariableSizeList as List } from "react-window"; // Import react-window
import PrimaryButton from "../GenericComponents/PrimaryButton";
import { useNotify } from "../../Helpers/Notifications";
import SpinnerComponent from "../GenericComponents/SpinnerComponent";
import { RotatingLines } from "react-loader-spinner";

const AddNewChatModal = ({
  contacts,
  handleSelectConversation,
  handleInviteContact,
}) => {
  const {
    setIsAddNewChatOpen,
    isAddNewChatOpen,
    isQcModalOpen,
    setIsQcModalOpen,
  } = useGenericComponentsStateService();
  const [searchValue, setSearchValue] = useState("");
  const { user } = useAuthService();
  const {
    fetchCoversation,
    conversations,
    currentConversationRef,
    setConversations,
    createGroup,
    createQuickChat,
    qcLinkRef,
  } = useConversationService();
  const { setLoading } = useGenericComponentsStateService();
  const [selectedContacts, setSelectedContacs] = useState([]);
  const [groupName, setGroupName] = useState("");
  const [qcName, setQcName] = useState("");
  const [previewAvatar, setPreviewAvatar] = useState();
  const [avatar, setAvatar] = useState();
  const { notifyError } = useNotify();
  const [listHeight, setListHeight] = useState(0);
  const [allContacts, setAllContacts] = useState([]);
  const listContainerRef = useRef(null);
  const containerRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslate();
  const themeColors = useTheme();
  const profileAvatarRef = useRef();
  const listRef = useRef(); // Create a ref for the list

  const handleOpenAvatar = () => {
    profileAvatarRef.current.click();
  };

  const handleAvatarChange = (e) => {
    setAvatar(e.target.files[0]);
    setPreviewAvatar(URL.createObjectURL(e.target.files[0]));
  };

  const handleCloseModla = (e) => {
    setIsAddNewChatOpen(false);
    setSelectedContacs([]);
    setSearchValue("");
    setGroupName("");
    setCategory(CHAT);
  };

  const [category, setCategory] = useState(CHAT);

  const searchContact = (list) => {
    const searchTerm = searchValue?.toLowerCase() || "";

    if (searchTerm === "") {
      return list;
    }

    return list.filter((item) => {
      const name = item?.name?.toLowerCase();
      return name?.includes(searchTerm); // Match anywhere in the string
    });
  };

  const handleStartNewChat = (contact) => {
    setLoading(true);
    let phone = contact.phone_number;
    let email = contact.email;
    if (
      (phone && phone === user.phone_number) ||
      (email && email === user.email)
    ) {
      notifyError(`${t('new_chat.cant_have_conv_with_u')}`);
      setLoading(false);
    } else {
      let dataObj = {};
      if (contact.phone_number) {
        dataObj.phone_number = phone;
      }
      if (contact.email) {
        dataObj.email = email;
      }
      fetchCoversation(
        dataObj,
        function (response) {
          const realConversation = response.data.conversation;
        
          setConversations(prevConversations => {
            const found = prevConversations.find(
              (item) => item.id === realConversation.id
            );
            if (found) {
              return prevConversations;
            } else {
              return [realConversation, ...prevConversations];
            }
          });
          currentConversationRef.current = realConversation;
          
          handleSelectConversation(realConversation, true);
          
          setIsAddNewChatOpen(false);
          setLoading(false);
        },
        function (error) {
          console.log(error, "error");
          notifyError(`${t('general.something_wrong')}`);
          setLoading(false);
        }
      );
    }
  };

  const handleCreateNewGroup = () => {
    setLoading(true);
    let membersId = selectedContacts.map((item) => {
      return item.id;
    });
    let clone = cloneDeep(conversations);
    let dataObj = new FormData();

    dataObj.append("name", groupName);
    dataObj.append("participants_ids", `[${membersId}]`);

    if (avatar) {
      dataObj.append("image", avatar);
    }

    createGroup(
      dataObj,
      function (response) {
        // let newConvList = [response.data.conversation].concat(clone);
        // currentConversationRef.current = clone;
        // setConversations(newConvList);
        handleSelectConversation(response.data.conversation);
        setLoading(false);
        backBtnClick();
      },
      function (error) {
        notifyError(`${t('general.something_wrong')}`);
        console.log(error);
        setLoading(false);
        backBtnClick();
      }
    );
  };

  const handleCreateQuickChat = (name) => {
    setLoading(true);
    createQuickChat(
      name,
      (response) => {
        let clone = cloneDeep(conversations);
        let found = clone.find(
          (item) => item.id === response.data.conversation.id
        );
        if (found) {
          handleSelectConversation(found);
        } else {
          // let newConvList = [response.data.conversation].concat(clone);
          // currentConversationRef.current = newConvList;
          // setConversations(newConvList);
          handleSelectConversation(response.data.conversation);
          qcLinkRef.current = response.data.conversation.url;
          setIsQcModalOpen(true);
        }

        setLoading(false);
      },
      (error) => {
        console.log(error);
        notifyError(t('general.something_wrong'));
        setLoading(false);
      }
    );
  };

  const handleCreateNewChat = (contact) => {
    handleStartNewChat(contact);
    // setIsAddNewChatOpen(false);
  };

  const hancleCreateQc = (name) => {
    handleCreateQuickChat(name);
    setIsAddNewChatOpen(false);
  };

  const backBtnClick = () => {
    setSelectedContacs([]);
    setSearchValue("");
    setGroupName("");
    setQcName("");
    setCategory(CHAT);
  };

  const handleCreateGroup = () => {
    handleCreateNewGroup();
    setIsAddNewChatOpen(false);
  };

  const isGroupValid = () => {
    if (groupName !== "" && selectedContacts.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const handleSelectContact = (contact) => {
    let found = selectedContacts.find((item) => item.id === contact.id);
    if (found) {
      let filtered = selectedContacts.filter((item) => item.id != contact.id);
      setSelectedContacs(filtered);
    } else {
      setSelectedContacs((prev) => {
        let newList = [...prev, contact];
        let sorted = newList.sort((a, b) => (a.name > b.name ? 1 : -1));
        return sorted;
      });
    }
  };

  const getItemSize = (index) => {
    const contact = allContacts[index];
    if (!contact) return 56; // Default size to prevent errors
    return contact.type === "header" ? 46 : 56;
  };

  let newChat = (
    <ContentWrapper ref={listContainerRef}>
      <ContentHeader>
        <Title>{t('new_chat.new_chat')}</Title>
        <CloseButton onClick={() => handleCloseModla()}>
          <CloseBtn />
        </CloseButton>
      </ContentHeader>
      <CardInputsWrapper>
        <OptionsWrapper style={{ height: "fit-content" }}>
          <SearchMenu value={searchValue} setvalue={setSearchValue} />
          <NewButton onClick={() => setCategory(GROUP)}>
            <GroupIcon /> {t('new_chat.new_group')}
          </NewButton>
          <NewButton onClick={() => setCategory(QUICK_CHAT)}>
            <QcIcon /> {t('new_chat.quick_chat')}
          </NewButton>
        </OptionsWrapper>

        {isLoading ? (
          <SpinnerWrapper>
            <RotatingLines
              strokeColor={themeColors.menu.selectedTextColor}
              strokeWidth={3}
              animationDuration="0.75"
              width={50}
              visible={true}
            />
          </SpinnerWrapper>
        ) : (
          <ContactsWrapper>
            <ContactListWrapper>
              <List
                ref={listRef} // Attach ref
                height={listHeight} // Adjust this based on the height of the container
                itemCount={allContacts.length}
                itemSize={getItemSize} // Adjust based on the size of each contact element
                width="100%" // Full width of the container
              >
                {({ index, style }) => {
                  const contact = allContacts[index];

                  if (contact.type === "header") {
                    return (
                      <SubtitleWrapper
                        key={index}
                        style={{ ...style, padding: "0 16px" }}
                      >
                        <Subtitle>{contact.value}</Subtitle>
                      </SubtitleWrapper>
                    );
                  }
                  if (contact.type === "contact") {
                    return (
                      <FoundContactElement
                        style={style}
                        key={contact.id}
                        item={contact}
                        handleSelectContact={handleCreateNewChat}
                        noCheck
                      />
                    );
                  }
                  if (contact.type === "outside") {
                    return (
                      <FoundContactElement
                        style={style}
                        key={index}
                        item={contact}
                        invite
                        handleInvite={handleInviteContact}
                        noCheck
                      />
                    );
                  }
                }}
              </List>
            </ContactListWrapper>
          </ContactsWrapper>
        )}
      </CardInputsWrapper>
    </ContentWrapper>
  );

  let content = newChat;
  let groupChat = (
    <ContentWrapper ref={listContainerRef}>
      <input
        type="file"
        hidden
        accept=".png, .jpg, .jpeg "
        ref={profileAvatarRef}
        onChange={(e) => handleAvatarChange(e)}
      />
      <ContentHeader>
        <HeaderSection style={{ justifyContent: "start" }}>
          <Title> {t('new_chat.new_group')} </Title>
        </HeaderSection>
        <HeaderSection></HeaderSection>
        <HeaderSection style={{ justifyContent: "end" }}>
          <CloseButton onClick={() => backBtnClick()}>
            <CloseBtn />
          </CloseButton>
        </HeaderSection>
      </ContentHeader>
      <CardInputsWrapper>
        <OptionsWrapper style={{ height: "fit-content", minHeight: "120px" }}>
          <GroupDetails style={{ gap: "16px" }}>
            <UserAvatar onClick={() => handleOpenAvatar()}>
              {previewAvatar ? (
                <CustomAvatar src={previewAvatar} alt="avatar" />
              ) : (
                <GenericAvatar />
              )}
            </UserAvatar>
            <CustomInput
              value={groupName}
              onChange={(e) => setGroupName(e.currentTarget.value)}
              name="groupName"
              maxLength={100}
              placeholder={t('new_chat.enter_group_name')}
            ></CustomInput>
          </GroupDetails>
          <SearchMenu value={searchValue} setvalue={setSearchValue} />
        </OptionsWrapper>

        {isLoading ? (
          <SpinnerWrapper>
            <RotatingLines
              strokeColor={themeColors.menu.selectedTextColor}
              strokeWidth={3}
              animationDuration="0.75"
              width={50}
              visible={true}
            />
          </SpinnerWrapper>
        ) : (
          <ContactsWrapper>
            <ContactListWrapper>
              <List
                ref={listRef} // Attach ref
                height={listHeight} // Adjust this based on the height of the container
                itemCount={allContacts.length}
                itemSize={getItemSize} // Adjust based on the size of each contact element
                width="100%" // Full width of the container
              >
                {({ index, style }) => {
                  const contact = allContacts[index];
                  if (contact.type === "header") {
                    return (
                      <SubtitleWrapper
                        key={index}
                        style={{ ...style, padding: "0 16px" }}
                      >
                        <Subtitle>{contact.value}</Subtitle>
                      </SubtitleWrapper>
                    );
                  }

                  if (contact.type === "contact") {
                    return (
                      <FoundContactElement
                        style={style}
                        key={contact.id}
                        item={contact}
                        handleSelectContact={handleSelectContact}
                        selected={selectedContacts.find(
                          (item) => item.id === contact.id
                        )}
                      />
                    );
                  }

                  if (contact.type === "outside") {
                    return (
                      <FoundContactElement
                        style={style}
                        key={index}
                        item={contact}
                        invite
                        handleInvite={handleInviteContact}
                        noCheck
                      />
                    );
                  }
                }}
              </List>
            </ContactListWrapper>
          </ContactsWrapper>
        )}
        {isGroupValid() && (
          <PrimaryButton
            onClick={() => handleCreateGroup()}
            style={{ margin: "16px", padding: "16px" }}
          >
            {t('new_chat.create')}
          </PrimaryButton>
        )}
      </CardInputsWrapper>
    </ContentWrapper>
  );

  let quickChat = (
    <ContentWrapper>
      <ContentHeader>
        <HeaderSection style={{ minWidth: "130px" }}>
          <Title> {t('new_chat.new_quick_chat')} </Title>
        </HeaderSection>
        <HeaderSection></HeaderSection>
        <HeaderSection style={{ justifyContent: "end" }}>
          <CloseButton onClick={() => backBtnClick()}>
            <CloseBtn />
          </CloseButton>
        </HeaderSection>
      </ContentHeader>

      <CardInputsWrapper>
        <OptionsWrapper>
          <GroupDetails>
            <CustomInput
              style={{ padding: "10px" }}
              value={qcName}
              onChange={(e) => setQcName(e.currentTarget.value)}
              name="qickChatName"
              maxLength={100}
              placeholder={t('new_chat.quick_chat_placeholder')}
            />
          </GroupDetails>
          {qcName !== "" && (
            <PrimaryButton
              onClick={() => hancleCreateQc(qcName)}
              text={t('new_chat.create_quick_chat')}
              style={{ padding: "14px" }}
            />
          )}
        </OptionsWrapper>
      </CardInputsWrapper>
    </ContentWrapper>
  );

  switch (category) {
    case CHAT:
      content = newChat;
      break;
    case GROUP:
      content = groupChat;
      break;
    case QUICK_CHAT:
      content = quickChat;
      break;

    default:
      break;
  }

  const insertContactTypeHeader = (arr) => {
    let newArr = [...arr];
    let hasContacts = newArr.some((item) => item.type === "contact");
    let hasOutsideContacts = newArr.some((item) => item.type === "outside");

    if (hasContacts) {
      newArr.unshift({ type: "header", value: t('new_chat.contacts_on_emotii') }); // Always at the start
    }

    if (hasOutsideContacts) {
      let indexB = newArr.findIndex((item) => item.type === "outside");
      newArr.splice(indexB, 0, { type: "header", value: t('new_chat.invite_contacts') });
    }

    return newArr;
  };

  useEffect(() => {
    if (!contacts) {
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    let mappedContacts = [];
    let mappedOutsideContacts = [];
    let allContacts = [];

    mappedContacts = contacts?.on_app_contacts?.map((item) => {
      return {
        ...item,
        type: "contact",
      };
    });
    mappedOutsideContacts = contacts?.outside_contacts?.map((item) => {
      return {
        ...item,
        type: "outside",
      };
    });

    if (isArray(mappedContacts) && isArray(mappedOutsideContacts)) {
      allContacts = [...mappedContacts, ...mappedOutsideContacts];
    } else {
      allContacts = [];
    }

    let availableContacs = searchContact(allContacts);
    let availableContacsWithHeaders = insertContactTypeHeader(availableContacs);

    setAllContacts(availableContacsWithHeaders);
    setIsLoading(false);
  }, [contacts, searchValue]);

  useEffect(() => {
    const updateHeight = () => {
      if (listContainerRef.current) {
        if (allContacts.length < 30) {
          setListHeight(allContacts.length * 56);
        } else {
          setListHeight(30 * 56);
        }
      }
    };

    updateHeight(); // Set height on mount
    window.addEventListener("resize", updateHeight); // Update on resize
    return () => window.removeEventListener("resize", updateHeight);
  }, [listContainerRef.current, allContacts]);

  useEffect(() => {
    if (listRef.current) {
      listRef.current.resetAfterIndex(0, true); // Force remeasure
    }
  }, [allContacts]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setIsAddNewChatOpen(false);
      }
    };

    if (isAddNewChatOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isAddNewChatOpen, setIsAddNewChatOpen]);

  return (
    <Container ref={containerRef}>
      <MenuContainer>{content}</MenuContainer>
    </Container>
  );
};

export default AddNewChatModal;

const Container = styled.div`
  background: ${({ theme }) => theme.chat.conversationBackground};
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  height: 100%;
  margin: auto;
  overflow: auto;
  border: 1px solid ${({ theme }) => theme.sidebar.borderColor};
`;

const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.menu.background};
  height: 100%;
  overflow: hidden;
  width: 100%;
  gap: 16px;
`;

const Title = styled.p`
  color: ${({ theme }) => theme.menu.primaryTextColor};
  font-weight: 700;
  font-size: 16px;
  line-height: 32px;
  letter-spacing: 0.04px;
  vertical-align: middle;
`;

const OptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;
  padding: 0 16px;
  overflow: auto;
  min-height: 156px;
  padding-bottom: 16px;
`;
const ContactListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;
const NewButton = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0.04px;
  vertical-align: middle;
  background: ${({ theme }) => theme.chat.selectedBackground};
  border: 1px solid ${({ theme }) => theme.sidebar.borderColor};
  padding: 12px 8px;
  border-radius: 4px;
  cursor: pointer;
`;

const SubtitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;
const Subtitle = styled.p`
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.04px;
  vertical-align: middle;
  text-transform: uppercase;
`;

const HeaderSection = styled.div`
  display: flex;
  width: 100%;
  min-width: 50px;
`;
const GroupDetails = styled.div`
  display: flex;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.sidebar.borderColor};
  padding: 8px 16px;
  align-items: center;
`;
const UserAvatar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  justify-content: center;
  background: ${({ selected, theme }) =>
    selected ? theme.sidebar.selectedBtnBackground : "transparent"};
  color: ${({ selected, theme }) =>
    selected ? theme.sidebar.selectedIconColor : theme.sidebar.iconColor};
  cursor: pointer;
  svg {
    width: 42px;
    height: 42px;
  }
`;
const CustomAvatar = styled.img`
  border-radius: 100px;
  width: 100%;
  object-fit: cover;
  width: 42px;
  height: 42px;
  position: relative;
  border-radius: 100px;
  border: 1px solid ${({ theme }) => theme.sidebar.avatarBorderColor};
`;

const CustomInput = styled.input`
  width: 100%;
  background: none;
  border: none;
  color: ${({ theme }) => theme.menu.primaryTextColor};
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.41px;
  height: fit-content;
  &:focus-visible {
    outline: none;
  }
  &::placeholder {
    font-weight: 400;
  }
`;
const CloseButton = styled.button`
border:none;
background:none;
cursor:pointer;
display:flex;
align-items:center;
justify-content:center;

svg{
height:24px;
width24px;
color:${({ theme }) => theme.menu.selectedOpionBackground};
stroke:${({ theme }) => theme.sidebar.borderColor};
}
`;

const ContentWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: hidden;
  gap: 16px;
  background: ${({ theme }) => theme.chat.conversationBackground};
`;

const ContactsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
`;
const ContentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 19px 16px;
  align-items: center;
  background: ${({ theme }) => theme.chat.conversationBackground};
  border-bottom: 1px solid ${({ theme }) => theme.sidebar.borderColor};
  gap: 20px;
`;
const CardInputsWrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin: 0 auto;
  width: 100%;
  max-width: 600px;
  overflow: auto;
`;

const SpinnerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 20px;
`;
